<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    Points
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Points')"><v-icon small class="mr-2">fa-plus</v-icon> Add Record</v-btn>
                    <point-record-dialog v-model="dialog" :item="editedItem" v-on:reloadpoints="refresh"></point-record-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="points"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.sensor_id }}</td>
        <td class="text-xs-left">{{ props.item.sensor_name }}</td>
        <td class="text-xs-left">
            {{props.item.sensor_name_abbr}}
        </td>
        <td class="text-xs-left">{{ props.item.unit }}</td>
        <td class="text-xs-left">{{ props.item.haystack_id }}</td>
        <td class="text-xs-left">{{ props.item.facility_name}}</td>
        <td class="text-xs-left">{{ props.item.weight}}</td>
        <td class="text-xs-left">{{ props.item.equipment_name}}</td>
        <td class="text-xs-left">{{ props.item.meta }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="$can('update', 'Points') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            @click="$can('update', 'Points') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getPoint, deletePoint} from '../helper'
import PointRecordDialog from '../components/points/PointRecordDialog'

export default {
    name: 'Points',
  components: { PointRecordDialog },
  data: () => ({
      dialog: false,
      headers: [
        {
          text: 'Sensor ID ',
          align: 'left',
          sortable: true,
          value: 'sensor_id'
        },
        { text: 'Sensor Name ', value: 'sensor_name' },
        { text: 'Sensor Name Abbr ', value: 'sensor_name_abbr' },
        { text: 'Unit ', value: 'unit', sortable: false },
        { text: 'Haystack ID ', value: 'haystack_id', sortable: false},
        { text: 'Facility Name ', value: 'facility_name'},
        { text: 'Weight ', value: 'weight'},
        { text: 'Equipment Name ', value: 'equipment_name'},
        { text: 'Meta ', value: 'meta', sortable: false },
        { text: 'Action ', sortable: false },
      ],
      points: [
        {
          'sensor_id': 1,
          'sensor_name': 'Sensor Name',
          'sensor_name_abbr': 'Sensor Name Abbr',
          'unit': 1,
          'faulty': false,
          'haystack_id': 1,
          'weight': 1,
          'facility_name': 'Facility Name',
          'equipment_name': 'Equipment Name',
          'meta': 'meta'
        },
      ],
      editedIndex: -1,
      editedItem: {
      },
    }),
    watch: {
      dialog (newdialog ) {
        this.refresh()
      }
    },
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.points.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.points.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') ){
          this.points.splice(index, 1)
          await deletePoint({
            'sensor_id': item.sensor_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.points[this.editedIndex], this.editedItem)
        } else {
          this.points.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
        let df = await getPoint({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
        })
        this.points = df['result']
      }
    }
  }
</script>

<style scoped>

</style>
